<template>
  <div class="w-100 h-100 flex-box bg-secondary">
    <a 
      class="block__absolute block__absolute--auto" 
      @click="$emit('backClickedFromRegister')">  <img 
        class="icon icon-xs" 
        src="@/assets/img/icons/svgs/solid/arrowLeft.svg"></a>
    <div class="card bg_disabled">
      <div class="card-header bg-transparent border-0 align-items-stretch w-100">
        <div class="logo-head mx-auto">
          <!-- <a>
            <img src="@/assets/img/brand/TaskFormcx-black.svg" />
          </a> -->
          <logo/>
        </div>
      </div>
      <div class="card-body">
        <div class="text-center">
          <p><b>Please fill up the form below:</b></p>
        </div>
        <form role="form">
          <base-input
            v-model="firstname"
            alternative
            class="mb-3"
            prepend-icon="ni ni-single-02"
            placeholder="First Name"
          />
          <div 
            v-if="$v.firstname.$error" 
            class="error field">First Name is required</div>
          <base-input
            v-model="lastname"
            alternative
            class="mb-3"
            prepend-icon="ni ni-single-02"
            placeholder="Last Name"
          />
          <div 
            v-if="$v.lastname.$error" 
            class="error field">Last Name is required</div>
          <base-input
            v-model="email"
            alternative
            class="mb-3"
            prepend-icon="ni ni-email-83"
            placeholder="Email"
          />
          <div 
            v-if="$v.email.$error" 
            class="error field">Valid email is required</div>

            <div 
            v-if="serverError.email" 
            class="error field">{{ serverError.email }}</div>

          <base-input
            v-model="password"
            alternative
            class="mb-3"
            prepend-icon="ni ni-lock-circle-open"
            type="password"
            placeholder="Password"
          />
         
          <div 
            v-if="$v.password.$error" 
            class="error field">Passwords should be a minimum of 8 Characters, with at least one uppercase, one lowercase and one number or special character.</div>
          <base-input
            v-model="confirm"
            alternative
            class="mb-3"
            prepend-icon="ni ni-lock-circle-open"
            type="password"
            placeholder="Confirm Password"
          />
          <div 
            v-if="$v.confirm.$required == false" 
            class="error field">Confirm password is required.</div>
          <div 
            v-if="$v.confirm.sameAsPassword == false" 
            class="error field">Confirm should match with password.</div>
                    
          <div class="text-center">
            <base-button 
              type="primary" 
              class="my-4 btn-block" 
              @click="handleRegistration">Register</base-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import { required, minLength, between, email, sameAs, helpers } from 'vuelidate/lib/validators'
import Logo from './Logo.vue'

const password = helpers.regex('password', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)
export default {
    name: "Register",
    components: {Logo},
    data() {
        return {
            firstname:"",
            lastname:"",
            email: "",
            password: "",
            confirm:"",
            serverError: {}
        }
    },
    validations: {
        firstname: {
            required
        },
        lastname: {
            required
        },
        email: {
            email,
            required
        },
        password: {
            password,
            required
        },
        confirm: {
            required,
            sameAsPassword: sameAs('password'),
        }
    },
   
    methods: {
        ...mapMutations(['setLoading']),
        ...mapMutations('user', ['setRegistrationData']),
        ...mapActions('user', ['performUserRegistration']),
        handleRegistration() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            // this.performLoginPassword({username:this.email, password:this.password}).then(r => {
            //    this.$router.push('/projects')
            // }).catch(err => {
            //     this.$snack.success('Invalid Credentials.')
            // })
            this.setLoading(true)
            this.performUserRegistration(
                {
                    first_name: this.firstname,
                    last_name: this.lastname,
                    password: this.password,
                    password_confirmation: this.confirm,
                    email: this.email
                }
            ).then(r => {
                this.setLoading(false)
                this.setRegistrationData(r.data)
                this.serverError = {}
                this.$emit('registerSuccess')
                
                
            }).catch(e => {
                if(e.response.status == 400) {
                   let res = e.response.data.message
                   this.serverError = {}
                   Object.keys(res).forEach((k, i) => {
                     
                     this.serverError[k] = res[k][0]
                   })
                    
                    //this.$snack.success(e.response.data.message[Object.keys(e.response.data.message)[0]][0])
                }

                this.setLoading(false)
            })
        }
    }
}
</script>

<style lang="sass">

</style>